/* SawaKart Quick add (theme only), loaded on every page (snippets/sk-head.liquid).

   The cards' Add button for a product with several variants opens this sheet instead of Empire's
   Quick Shop (whose gallery was hidden and broken): the photo of the chosen variant, photo tiles for
   one option (the colour, or the first option whose values have their own photos), pills for the
   others, price, quantity, "Add to Cart — $total" and "View full details". A centred dialog on
   computers, a bottom sheet on phones (styles: assets/sk-quick-add.css).
   - Triggers: [data-sk-quick-add="<handle>"] (home cards, snippets/sk-product-card.liquid) and
     SK.quickAdd.open(handle, { trigger }) (Empire cards, snippets/custom-footer-js.liquid).
   - Data: the public /products/<handle>.js. Adding: SK.cart.add (sk-core.js), which opens the cart
     sidebar; errors show inside the sheet. If the product can't be loaded, the product page opens.
   - SK.radioKeys(group, onPick) is shared with assets/sk-product.js (arrow keys in a radio group). */
(function () {
  'use strict';
  var SK = window.SK = window.SK || {};
  if (SK.quickAdd) return;

  var html = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var MAX_QTY = 999;
  var cache = {};

  var ICON_X = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
  var ICON_SEARCH = '<svg class="skv-search__ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';

  /* ---------- helpers ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var text = SK.formatMoney ? SK.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
    return String(text).replace(/^\$\s+/, '$');
  }

  // Shopify CDN image at a given width.
  function sized(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function rootUrl() {
    var r = (window.skTheme && skTheme.routes && skTheme.routes.root_url) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* Arrow keys / Home / End move between the radios of a group and pick them (roving tabindex). */
  SK.radioKeys = function (group, onPick) {
    group.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 0, End: 0 };
      if (!(e.key in keys)) return;
      var radios = Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function (r) { return !r.hidden; });
      var i = radios.indexOf(document.activeElement);
      if (i === -1 || !radios.length) return;
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? radios.length - 1 : (i + keys[e.key] + radios.length) % radios.length;
      radios[n].focus();
      onPick(radios[n]);
    });
  };

  /* Keep one tab stop per radio group: the checked radio (or the first one). */
  SK.radioTabStops = function (group) {
    var radios = group.querySelectorAll('[role="radio"]');
    var checked = group.querySelector('[role="radio"][aria-checked="true"]:not([hidden])');
    each(radios, function (r) { r.tabIndex = -1; });
    var first = checked || Array.prototype.filter.call(radios, function (r) { return !r.hidden; })[0];
    if (first) first.tabIndex = 0;
  };

  /* ---------- product model ---------- */

  function Model(p) {
    this.p = p;
    this.variants = p.variants || [];
    this.optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    this.media = (p.media || []).filter(function (m) { return m && (m.preview_image || m.src); }).map(function (m) {
      return { id: String(m.id), src: (m.preview_image && m.preview_image.src) || m.src };
    });
    if (!this.media.length) {
      this.media = (p.images || []).map(function (src, i) { return { id: 'img' + i, src: src }; });
    }
    this.current = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
    this.selected = this.current ? this.current.options.slice() : [];
  }

  Model.prototype.valuesOf = function (i) {
    var seen = {};
    var out = [];
    this.variants.forEach(function (v) {
      var val = v.options[i];
      if (val != null && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  };

  Model.prototype.exact = function (opts) {
    return this.variants.filter(function (v) {
      for (var i = 0; i < opts.length; i++) if (v.options[i] !== opts[i]) return false;
      return true;
    })[0] || null;
  };

  // The variant with `value` at option `index` that keeps most of the other chosen options.
  Model.prototype.closest = function (index, value) {
    var self = this;
    var best = null;
    var bestScore = -1;
    this.variants.forEach(function (v) {
      if (v.options[index] !== value) return;
      var score = 0;
      v.options.forEach(function (o, i) { if (o === self.selected[i]) score += 2; });
      if (v.available) score += 1;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  };

  // The primary option (the colour, else the first option with a choice): only crossed out when sold out in every
  // other option. Same rule as sections/sk-product.liquid.
  Model.prototype.primaryOption = function () {
    var p = this.photoOption();
    for (var i = 0; p === -1 && i < this.optionNames.length; i++) if (this.valuesOf(i).length > 1) p = i;
    return p === -1 ? 0 : p;
  };

  Model.prototype.variantFor = function (index, value) {
    var opts = this.selected.slice();
    opts[index] = value;
    return this.exact(opts) || this.closest(index, value);
  };

  Model.prototype.imageOf = function (v) {
    if (!v) return null;
    if (v.featured_media && v.featured_media.preview_image) return v.featured_media.preview_image.src;
    return v.featured_image ? v.featured_image.src : null;
  };

  Model.prototype.mediaIndexOf = function (v) {
    if (!v || !v.featured_media) return -1;
    var id = String(v.featured_media.id);
    for (var i = 0; i < this.media.length; i++) if (this.media[i].id === id) return i;
    return -1;
  };

  // Only one option gets photo tiles: the colour when its values show at least two different photos,
  // else the first such option (sizes stay pills even when each size has its own photo).
  Model.prototype.photoOption = function () {
    if (this._photoOption !== undefined) return this._photoOption;
    var self = this;
    var first = -1;
    var colour = -1;
    this.optionNames.forEach(function (name, i) {
      if (self.valuesOf(i).length < 2 || !self.hasPhotos(i)) return;
      if (first === -1) first = i;
      if (colour === -1 && /colou?r/i.test(name)) colour = i;
    });
    this._photoOption = colour !== -1 ? colour : first;
    return this._photoOption;
  };

  // True when the values of option i show at least two different photos.
  Model.prototype.hasPhotos = function (i) {
    var self = this;
    var srcs = {};
    var count = 0;
    this.valuesOf(i).forEach(function (val) {
      var v = self.variants.filter(function (x) { return x.options[i] === val && self.imageOf(x); })[0];
      var src = self.imageOf(v);
      if (src && !srcs[src]) { srcs[src] = true; count += 1; }
    });
    return count >= 2;
  };

  /* ---------- sheet ---------- */

  var dialog = null;
  var state = null; // { model, qty, index, trigger, busy, root }

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'skq';
    dialog.setAttribute('aria-labelledby', 'skq-title');
    dialog.innerHTML =
      '<div class="skq__panel" tabindex="-1">' +
      '<span class="skq__grab" aria-hidden="true"></span>' +
      '<button type="button" class="skq__close" data-skq-close aria-label="Close">' + ICON_X + '</button>' +
      '<div class="skq__body" data-skq-body style="display:contents"></div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-skq-close]'))) close();
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });
    dialog.addEventListener('close', function () {
      html.classList.remove('skq-lock');
      dialog.classList.remove('is-closing');
      var back = state && state.trigger;
      state = null;
      if (back && back.isConnected && typeof back.focus === 'function') {
        try { back.focus({ preventScroll: true }); } catch (err) { /* not focusable */ }
      }
    });
  }

  function body() { return dialog.querySelector('[data-skq-body]'); }

  function showLoading() {
    body().innerHTML = '<div class="skq__scroll"><div class="skq__loading" role="status"><span class="skq__spin"></span>Loading options…</div></div>';
  }

  function close(keepFocus) {
    if (!dialog || !dialog.open) return;
    if (keepFocus && state) state.trigger = null;
    if (reduced) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    setTimeout(function () { if (dialog.open) dialog.close(); }, 200);
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (p) {
      cache[handle] = p;
      return p;
    });
  }

  function open(handle, opts) {
    opts = opts || {};
    if (!handle) return;
    ensureDialog();
    var token = {};
    state = { token: token, trigger: opts.trigger || document.activeElement, qty: 1, index: 0, busy: false };
    showLoading();
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    html.classList.add('skq-lock');
    // Start on the sheet itself (no focus ring on a control); Tab reaches the options and Add.
    dialog.querySelector('.skq__panel').focus({ preventScroll: true });
    load(handle).then(function (p) {
      if (!state || state.token !== token) return;
      render(new Model(p));
    }).catch(function () {
      if (!state || state.token !== token) return;
      window.location.assign(rootUrl() + 'products/' + encodeURIComponent(handle));
    });
  }

  function optionMarkup(model, i) {
    var name = model.optionNames[i] || 'Option';
    var photos = model.photoOption() === i;
    var values = model.valuesOf(i);
    if (!photos && SK.sortOptionValues) values = SK.sortOptionValues(values); // sizes in order (sk-head.liquid)
    var many = values.length > 12;
    var out = '<div class="skv-option" data-skq-option="' + i + '">' +
      '<p class="skv-option__head"><span class="skv-option__name">' + esc(name) + ':</span> ' +
      '<span class="skv-option__value" data-skq-value>' + esc(model.selected[i]) + '</span></p>';
    if (many) {
      out += '<div class="skv-search">' + ICON_SEARCH +
        '<input type="text" class="skv-search__input" data-skq-search placeholder="Search ' + esc(name.toLowerCase()) + '…" aria-label="Search ' + esc(name.toLowerCase()) + '" autocomplete="off"></div>' +
        '<p class="skv-empty" data-skq-empty hidden>No matches</p>';
    }
    out += '<div class="' + (photos ? 'skv-tiles' : 'skv-pills') + (many ? (photos ? ' skv-tiles--scroll' : ' skv-pills--scroll') : '') +
      '" role="radiogroup" aria-label="' + esc(name) + '">';
    values.forEach(function (val) {
      if (photos) {
        out += '<button type="button" class="skv-tile" role="radio" aria-checked="false" data-value="' + esc(val) + '" aria-label="' + esc(val) + '">' +
          '<span class="skv-tile__check">' + ICON_CHECK + '</span>' +
          '<span class="skv-tile__img"><img alt="" loading="lazy" width="96" height="96" data-skq-tile-img>' +
          '<span class="skv-tile__oos">Sold out</span></span>' +
          '<span class="skv-tile__name">' + esc(val).replace(/\//g, '/<wbr>') + '</span></button>';
      } else {
        out += '<button type="button" class="skv-pill" role="radio" aria-checked="false" data-value="' + esc(val) + '">' + esc(val) + '</button>';
      }
    });
    return out + '</div></div>';
  }

  function render(model) {
    var p = model.p;
    var multi = [];
    model.optionNames.forEach(function (n, i) { if (model.valuesOf(i).length > 1) multi.push(i); });
    // The colour (photo) option is the primary choice: shown first, like the product page.
    var primary = model.primaryOption();
    if (multi.indexOf(primary) > 0) multi = [primary].concat(multi.filter(function (i) { return i !== primary; }));
    var url = p.url || (rootUrl() + 'products/' + p.handle);
    var thumbs = '';
    if (model.media.length > 1) {
      // One Tab stop for the strip; arrow keys move between photos (SK.radioKeys).
      thumbs = '<div class="skq__thumbs" role="radiogroup" aria-label="Photos">' + model.media.map(function (m, i) {
        return '<button type="button" class="skq__thumb" role="radio" aria-checked="false" tabindex="-1" data-skq-thumb="' + i + '" aria-label="Photo ' + (i + 1) + ' of ' + model.media.length + '">' +
          '<img src="' + esc(sized(m.src, 120)) + '" alt="" loading="lazy" width="52" height="52"></button>';
      }).join('') + '</div>';
    }
    body().innerHTML =
      '<div class="skq__scroll"><div class="skq__grid">' +
        '<div class="skq__media">' +
          '<div class="skq__photo"><img data-skq-photo alt="' + esc(p.title) + '" width="600" height="600"></div>' + thumbs +
        '</div>' +
        '<div class="skq__info">' +
          (p.vendor ? '<p class="skq__brand">' + esc(p.vendor) + '</p>' : '') +
          '<h2 class="skq__title" id="skq-title"><a href="' + esc(url) + '" data-skq-link>' + esc(p.title) + '</a></h2>' +
          '<div class="skq__price"><span class="skq__now" data-skq-price></span><span class="skq__was" data-skq-was hidden></span><span class="skq__save" data-skq-save hidden></span></div>' +
          '<p class="skq__stock" data-skq-stock hidden>Sold out</p>' +
          (multi.length ? '<hr class="skq__rule">' + multi.map(function (i) { return optionMarkup(model, i); }).join('') : '') +
          '<p class="skq__error" data-skq-error role="alert" hidden></p>' +
        '</div>' +
      '</div></div>' +
      '<div class="skq__footer">' +
        '<div class="skq-qty"><button type="button" class="skq-qty__btn" data-skq-minus aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
        '<span class="skq-qty__value" data-skq-qty aria-live="polite">1</span>' +
        '<button type="button" class="skq-qty__btn" data-skq-plus aria-label="Increase quantity">' + ICON_PLUS + '</button></div>' +
        '<button type="button" class="skq__atc" data-skq-atc><span data-skq-atc-label>Add to Cart</span></button>' +
        '<a class="skq__details" href="' + esc(url) + '" data-skq-details>View full details →</a>' +
      '</div>';
    state.model = model;
    state.root = body();
    state.index = Math.max(0, model.mediaIndexOf(model.current));
    bind();
    update({ photo: true });
    thumbsFade();
  }

  // Phones: the thumbnails scroll sideways; fade the right edge while more are hidden there.
  function thumbsFade() {
    var strip = state && state.root.querySelector('.skq__thumbs');
    if (!strip) return;
    strip.classList.toggle('has-more', strip.scrollLeft + strip.clientWidth < strip.scrollWidth - 2);
  }

  function choose(index, value) {
    var model = state.model;
    var v = model.variantFor(index, value);
    if (!v) return;
    model.current = v;
    model.selected = v.options.slice();
    hideError();
    update({ photo: true });
  }

  function showPhoto(i, fromVariant) {
    var model = state.model;
    if (!model.media.length) return;
    i = ((i % model.media.length) + model.media.length) % model.media.length;
    state.index = i;
    setPhoto(model.media[i].src);
    var strip = state.root.querySelector('.skq__thumbs');
    each(state.root.querySelectorAll('[data-skq-thumb]'), function (t) {
      var on = parseInt(t.getAttribute('data-skq-thumb'), 10) === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) {
        // keep the active thumbnail in view inside the strip (without scrolling the page)
        if (strip && strip.scrollWidth > strip.clientWidth) {
          var left = t.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + t.offsetWidth - strip.clientWidth;
        }
      }
    });
    if (strip) SK.radioTabStops(strip);
    if (!fromVariant) {
      // A photo of a variant picks that variant (keeping the other options when possible).
      var id = model.media[i].id;
      var best = null;
      var bestScore = -1;
      model.variants.forEach(function (v) {
        if (!v.featured_media || String(v.featured_media.id) !== id) return;
        var score = 0;
        v.options.forEach(function (o, n) { if (o === model.selected[n]) score += 2; });
        if (v.available) score += 1;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (best && best !== model.current) {
        model.current = best;
        model.selected = best.options.slice();
        update({ photo: false });
      }
    }
  }

  function setPhoto(src) {
    var img = state.root.querySelector('[data-skq-photo]');
    if (!img || !src) return;
    var next = sized(src, 800);
    if (img.getAttribute('src') === next) return;
    img.classList.add('is-loading');
    img.onload = img.onerror = function () { img.classList.remove('is-loading'); };
    img.setAttribute('src', next);
  }

  function update(opts) {
    var model = state.model;
    var v = model.current;
    var root = state.root;
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    root.querySelector('[data-skq-price]').textContent = money(v.price);
    root.querySelector('[data-skq-price]').classList.toggle('is-sale', !!sale);
    var was = root.querySelector('[data-skq-was]');
    var save = root.querySelector('[data-skq-save]');
    was.hidden = !sale;
    save.hidden = !sale;
    if (sale) {
      was.textContent = money(v.compare_at_price);
      save.textContent = 'Save ' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
    }
    root.querySelector('[data-skq-stock]').hidden = v.available;

    each(root.querySelectorAll('[data-skq-option]'), function (box) {
      var i = parseInt(box.getAttribute('data-skq-option'), 10);
      box.querySelector('[data-skq-value]').textContent = model.selected[i];
      var group = box.querySelector('[role="radiogroup"]');
      each(group.querySelectorAll('[role="radio"]'), function (r) {
        var val = r.getAttribute('data-value');
        var on = val === model.selected[i];
        var ex;
        if (i === model.primaryOption()) {
          var withVal = model.variants.filter(function (x) { return x.options[i] === val; });
          ex = withVal.filter(function (x) { return x.available; })[0] || withVal[0] || null;
        } else {
          // Crossed out when this value does not exist with the chosen colour, or that exact variant is sold out.
          var opts = model.selected.slice();
          opts[i] = val;
          ex = model.exact(opts);
        }
        var cand = (i === model.primaryOption() ? null : ex) || model.variantFor(i, val);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
        var oos = !(ex && ex.available);
        r.classList.toggle('is-oos', oos);
        r.setAttribute('aria-label', val + (!ex ? ' (not available with the selected options)' : oos ? ' (sold out)' : ''));
        var badge = r.querySelector('.skv-tile__oos');
        if (badge) badge.textContent = ex ? 'Sold out' : 'Not available';
        var img = r.querySelector('[data-skq-tile-img]');
        if (img) {
          var src = model.imageOf(cand) || model.imageOf(model.variants.filter(function (x) { return x.options[i] === val; })[0]);
          if (src && img.getAttribute('src') !== sized(src, 200)) img.setAttribute('src', sized(src, 200));
        }
      });
      SK.radioTabStops(group);
    });

    if (opts.photo) {
      var mi = model.mediaIndexOf(v);
      if (mi >= 0) showPhoto(mi, true);
      else if (!root.querySelector('[data-skq-photo]').getAttribute('src')) showPhoto(state.index, true);
    }

    var link = (model.p.url || (rootUrl() + 'products/' + model.p.handle)) + '?variant=' + v.id;
    root.querySelector('[data-skq-details]').setAttribute('href', link);
    root.querySelector('[data-skq-link]').setAttribute('href', link);
    renderAtc();
  }

  function renderAtc() {
    var v = state.model.current;
    var root = state.root;
    root.querySelector('[data-skq-qty]').textContent = state.qty;
    root.querySelector('[data-skq-minus]').disabled = !v.available || state.qty <= 1;
    root.querySelector('[data-skq-plus]').disabled = !v.available || state.qty >= MAX_QTY;
    if (state.busy) return;
    var atc = root.querySelector('[data-skq-atc]');
    atc.disabled = !v.available;
    atc.querySelector('[data-skq-atc-label]').textContent = v.available ? 'Add to Cart — ' + money(v.price * state.qty) : 'Sold out';
  }

  function showError(msg) {
    var box = state.root.querySelector('[data-skq-error]');
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError() {
    var box = state && state.root && state.root.querySelector('[data-skq-error]');
    if (box) box.hidden = true;
  }

  function addToCart() {
    var v = state.model.current;
    if (state.busy || !v.available) return;
    var atc = state.root.querySelector('[data-skq-atc]');
    var token = state.token;
    if (!(SK.cart && typeof SK.cart.add === 'function')) {
      window.location.assign((state.model.p.url || '/') + '?variant=' + v.id);
      return;
    }
    state.busy = true;
    hideError();
    atc.disabled = true;
    atc.querySelector('[data-skq-atc-label]').innerHTML = '<span style="display:inline-flex;align-items:center;gap:.5rem"><span class="skq__spin"></span>Adding…</span>';
    SK.cart.add(v.id, state.qty, atc).then(function () {
      if (!state || state.token !== token) return;
      state.busy = false;
      close(true); // the cart sidebar is open on top and has the focus
    }, function (err) {
      if (!state || state.token !== token) return;
      state.busy = false;
      renderAtc();
      showError((err && err.skDescription) || "Couldn't add to cart. Please try again.");
    });
  }

  function bind() {
    var root = state.root;
    each(root.querySelectorAll('[data-skq-option]'), function (box) {
      var i = parseInt(box.getAttribute('data-skq-option'), 10);
      var group = box.querySelector('[role="radiogroup"]');
      group.addEventListener('click', function (e) {
        var r = e.target.closest('[role="radio"]');
        if (r) choose(i, r.getAttribute('data-value'));
      });
      SK.radioKeys(group, function (r) { choose(i, r.getAttribute('data-value')); });
      // Computers: hovering a photo tile previews its photo.
      if (canHover && group.classList.contains('skv-tiles')) {
        group.addEventListener('mouseover', function (e) {
          if (!state.moved) return; // not for a cursor that was already where the sheet opened
          var r = e.target.closest('[role="radio"]');
          if (!r) return;
          var src = state.model.imageOf(state.model.variantFor(i, r.getAttribute('data-value')));
          if (src) setPhoto(src);
        });
        group.addEventListener('mouseleave', function () {
          var m = state.model.media[state.index];
          if (m) setPhoto(m.src);
        });
      }
      var search = box.querySelector('[data-skq-search]');
      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          var shown = 0;
          each(group.querySelectorAll('[role="radio"]'), function (r) {
            var hide = !!q && r.getAttribute('data-value').toLowerCase().indexOf(q) === -1;
            r.hidden = hide;
            if (!hide) shown += 1;
          });
          box.querySelector('[data-skq-empty]').hidden = shown > 0;
          SK.radioTabStops(group);
        });
      }
    });
    root.parentNode.addEventListener('mousemove', function () { if (state) state.moved = true; }, { once: true });
    var strip = root.querySelector('.skq__thumbs');
    if (strip) {
      strip.addEventListener('scroll', thumbsFade, { passive: true });
      SK.radioKeys(strip, function (t) { showPhoto(parseInt(t.getAttribute('data-skq-thumb'), 10), false); });
    }
    each(root.querySelectorAll('[data-skq-thumb]'), function (t) {
      t.addEventListener('click', function () { showPhoto(parseInt(t.getAttribute('data-skq-thumb'), 10), false); });
    });
    root.querySelector('[data-skq-minus]').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); renderAtc(); });
    root.querySelector('[data-skq-plus]').addEventListener('click', function () { state.qty = Math.min(MAX_QTY, state.qty + 1); renderAtc(); });
    root.querySelector('[data-skq-atc]').addEventListener('click', addToCart);
  }

  /* ---------- triggers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sk-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.getAttribute('data-sk-quick-add'), { trigger: btn });
  });

  window.addEventListener('resize', function () { if (state && state.model) thumbsFade(); });

  SK.quickAdd = { open: open, close: close };
})();
